"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUserProperties = exports.setIdentity = exports.trackEvent = void 0;

var _reduxAct = require("redux-act");

var PREFIX = 'SERVICES/SEGMENT_EVENTS';
var trackEvent = (0, _reduxAct.createAction)("".concat(PREFIX, "/SEND_SEGMENT_EVENT"));
exports.trackEvent = trackEvent;
var setIdentity = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_IDENTITY"));
exports.setIdentity = setIdentity;
var addUserProperties = (0, _reduxAct.createAction)("".concat(PREFIX, "/ADD_USER_PROPERTIES"));
exports.addUserProperties = addUserProperties;